export default {
  // 主题基本信息
  code: 'zero-carbon',
  name: '全国大学生零碳科技创新大赛',
  description: '零碳科技创新作品征集',
  
  // 路由配置
  routeBase: '/zero-carbon',
  
  // 主题路由定义
  routes: [
    { path: '', component: 'Promo', meta: { title: '首页' } },
    { path: 'gallery', component: 'Gallery', meta: { title: '作品展示' } },
    { path: 'work-submit', component: 'WorkSubmit', meta: { title: '提交作品' }, auth: true },
    { path: 'work/detail/:id', component: 'WorkDetail', meta: { title: '作品详情' } },
    { path: 'user/center', component: 'UserCenter', meta: { title: '个人中心' }, auth: true },
    { path: 'my-works', component: 'MyWorks', meta: { title: '我的作品' }, auth: true },
    { path: 'login', component: 'Login', meta: { title: '登录' } },
    { path: 'register', component: 'Register', meta: { title: '注册' } }
  ],
  
  // 主题样式
  themeColor: '#00d4aa',
  secondaryColor: '#00a8ff',
  
  // API配置
  apiPrefix: '/portal',
  
  // 扩展配置
  extra: {
    organization: '中国环境科学学会',
    location: '福建省宁德市',
    year: 2026
  }
}
